//* Deals Price Toggle Controller
//*
//* Switches the public deals listing (table and card views alike)
//* between the total package price (original + final) and the
//* calculated price per night. The selection is saved to localStorage.
import ApplicationController from "application_controller.js";

const STORAGE_KEY = "deals_price";

export default class extends ApplicationController {
  debug = false;

  static targets = ["table", "cards", "totalButton", "nightlyButton"];

  connect() {
    if (localStorage.getItem(STORAGE_KEY) === "nightly") {
      this.nightlyView();
    }
  }

  totalView() {
    this.containers.forEach((container) => container.classList.remove("show-nightly"));
    this.totalButtonTarget.classList.add("active");
    this.nightlyButtonTarget.classList.remove("active");
    localStorage.setItem(STORAGE_KEY, "total");
  }

  nightlyView() {
    this.containers.forEach((container) => container.classList.add("show-nightly"));
    this.nightlyButtonTarget.classList.add("active");
    this.totalButtonTarget.classList.remove("active");
    localStorage.setItem(STORAGE_KEY, "nightly");
  }

  //* Lazy-loaded containers connect later and must match the current selection
  tableTargetConnected(table) {
    this.syncContainer(table);
  }

  cardsTargetConnected(cards) {
    this.syncContainer(cards);
  }

  get containers() {
    return [...this.tableTargets, ...this.cardsTargets];
  }

  syncContainer(container) {
    if (localStorage.getItem(STORAGE_KEY) === "nightly") {
      container.classList.add("show-nightly");
    }
  }
}
